<template>
  <v-card>
    <div class="flex-grow-1 px-2">
      <div class="title-bar d-flex justify-space-between">
        <div>
          <div class="title">
            Certifikat - {{error.company_name}}
          </div>
        </div>
        <div class="actions">
        </div>
      </div>
      <v-card-text>
        <v-row>
          <div class="user-card-label">
            Podjetje
          </div>
          <div class="user-card-value">
            {{error.company_name}}
          </div>
        </v-row>
        <v-row>
          <div class="user-card-label">
            Veljaven od:
          </div>
          <div class="user-card-value">
            {{error.valid_from}}
          </div>
        </v-row>
        <v-row>
          <div class="user-card-label">
            Veljaven do:
          </div>
          <div class="user-card-value">
            {{error.valid_to}}
          </div>
        </v-row>
        <v-row>
          <div class="user-card-label">
            Potekel
          </div>
          <div class="user-card-value">
            {{error.expired ? 'Da' : 'Ne'}}
          </div>
        </v-row>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
export default {
  components: {
  },
  props: {
    error: {
      required: true,
      type: Object
    }
  }
}
</script>

<style lang="scss" scoped>
  .v-card {
    padding: 20px;
    &.not-active {
      background-color: #F5F5F5;
      border: 1px solid #EEEEEE;
    }
  }
  .title-bar {
    padding: 10px;
    padding-bottom: 20px;
    box-shadow: 0 4px 3px -5px #455A64;

    .title {
      font-size: 22px;
      font-weight: bold;
      color: #607D8B;
    }
    .subtitle {
      color: #B0BEC5;
      font-size: 12px;
    }
    .actions {
      min-width: 30px;
      max-width: 30px;
      margin-left: 15px;
    }
  }
  .v-card__text {
    padding: 6px 0px 6px 32px;
    .user-card-label {
      min-width: 120px;
      display: inline-block;
      color: #BDBDBD;
      &.sublabel {
        text-align: right;
        padding-right: 22px;
      }
    }
    .user-card-value {
      color: #607D8B;
      font-weight: bold;
      display: inline-block;
      max-width: calc(100% - 150px);
      min-width: 110px;
    }
  }
</style>
